import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { Strong, Visible } from 'main/ui'
import { IRangeProps } from 'main/ui/slider/RangeSlider'
import TimeRangeSlider from 'main/ui/slider/TimeRangeSlider'
import { getTimeAsString, getTimeInMinutes } from 'main/ui/slider/util'
import { IFilters } from 'main/util/search'
import { useTranslation } from 'react-i18next'
import {
  Apply,
  Clear,
  FilterFormContainer,
  FilterFormSubmitContainer,
} from '../../common/FilterForm.styles'
import { ISearchFormProps } from '../../types'

const maxValue = 23.75 * 60
const minValue = 13 * 60

const PRE = `${i18nKeyPrefix}-FILTERS-PICK-UP-FORM`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props

  const [params, setParams] = React.useState<IFilters>({ ...filters })
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <FilterFormContainer>
      <Fields params={params} onChangeParams={setParams} />
      <Visible lg xl>
        <FilterFormSubmitContainer>
          <Clear data-pendo="hoursFilter-pickUpTime-clear" onClick={() => handleClear()}>
            {t(`${PRE}-CLEAR`)}
          </Clear>
          <Apply data-pendo="hoursFilter-pickUpTime-apply" onClick={() => handleApply()}>
            {t(`${PRE}-APPLY`)}
          </Apply>
        </FilterFormSubmitContainer>
      </Visible>
    </FilterFormContainer>
  )

  function handleApply() {
    onRequestCloseForm()
    onChangeFilters({
      ...filters,
      pickUpEndsAt: params.pickUpEndsAt,
      pickUpStartsAt: params.pickUpStartsAt,
    })
  }

  function handleClear() {
    setParams({ ...params, pickUpEndsAt: null, pickUpStartsAt: null })
  }
}

interface IFieldsProps {
  params: IFilters
  onChangeParams: (params: IFilters) => void
}

export function Fields(fieldsProps: IFieldsProps) {
  const { params, onChangeParams } = fieldsProps
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <>
      <Strong>{t(`${PRE}-LABEL`)}</Strong>
      <TimeRangeSlider
        data-pendo="hoursFilter-pickUpTime"
        maxValue={maxValue}
        minValue={minValue}
        step={15}
        value={{
          max: params.pickUpEndsAt ? getTimeInMinutes(params.pickUpEndsAt) : maxValue,
          min: params.pickUpStartsAt ? getTimeInMinutes(params.pickUpStartsAt) : minValue,
        }}
        onChange={value => handleChange(value)}
      />
    </>
  )

  function handleChange(value: IRangeProps) {
    const pickUpEndsAt =
      value.max >= maxValue && value.min <= minValue ? null : getTimeAsString(value.max)
    const pickUpStartsAt =
      value.min <= minValue && value.max >= maxValue ? null : getTimeAsString(value.min)

    onChangeParams({ ...params, pickUpEndsAt, pickUpStartsAt })
  }
}
